import React, { FC } from 'react';

import { IMarketingCardFragment } from 'generated/sanity-graphql';

import { MarketingCard } from '../marketing-card';
import { OnShowModalType } from '../marketing-card/types';

import { Container } from './styled';

interface MarketingCardGroupProps {
  cards: ReadonlyArray<IMarketingCardFragment | null>;
  onShowTermsModal: OnShowModalType;
}

/** Renders a selected card set; the consuming surface owns feed selection and state. */
export const MarketingCardGroup: FC<React.PropsWithChildren<MarketingCardGroupProps>> = ({
  cards,
  onShowTermsModal,
  children,
}) => {
  if (!cards.length && React.Children.count(children) === 0) {
    return null;
  }

  return (
    <Container testID="marketing-tile-group-grid">
      {children}
      {cards.map((card, index) => {
        if (!card) {
          return null;
        }
        const key = `MarketingCard_${card._id}`;
        return (
          <MarketingCard key={key} card={card} onShowTermsModal={onShowTermsModal} index={index} />
        );
      })}
    </Container>
  );
};
